// src/questions.ts
import { Question } from "./types";

export const questions: Question[] = [
  // --- PHẦN 1: QUY LUẬT SỐ HỌC (10 Câu) ---
  {
    id: 1,
    questionText: "Số nào tiếp theo trong dãy số: 2, 4, 8, 16, ...?",
    options: [
      { key: "A", text: "24", isCorrect: false },
      { key: "B", text: "32", isCorrect: true }, // Nhân đôi
      { key: "C", text: "20", isCorrect: false },
      { key: "D", text: "48", isCorrect: false },
    ],
  },
  {
    id: 2,
    questionText: "Tìm số còn thiếu: 1, 4, 9, 16, 25, ...",
    options: [
      { key: "A", text: "36", isCorrect: true }, // Bình phương các số tự nhiên liên tiếp
      { key: "B", text: "30", isCorrect: false },
      { key: "C", text: "49", isCorrect: false },
      { key: "D", text: "32", isCorrect: false },
    ],
  },
  {
    id: 3,
    questionText: "Số nào tiếp theo: 0, 1, 1, 2, 3, 5, 8, ...",
    options: [
      { key: "A", text: "11", isCorrect: false },
      { key: "B", text: "13", isCorrect: true }, // Dãy Fibonacci
      { key: "C", text: "12", isCorrect: false },
      { key: "D", text: "15", isCorrect: false },
    ],
  },
  {
    id: 4,
    questionText: "Điền vào dấu hỏi: 10, 20, 15, 30, 25, ?",
    options: [
      { key: "A", text: "50", isCorrect: true }, // Nhân 2, trừ 5, nhân 2, trừ 5... (25 * 2 = 50)
      { key: "B", text: "35", isCorrect: false },
      { key: "C", text: "40", isCorrect: false },
      { key: "D", text: "45", isCorrect: false },
    ],
  },
  {
    id: 5,
    questionText: "Số nào khác biệt với các số còn lại: 7, 13, 17, 20, 23",
    options: [
      { key: "A", text: "7", isCorrect: false },
      { key: "B", text: "17", isCorrect: false },
      { key: "C", text: "20", isCorrect: true }, // Số duy nhất không phải số nguyên tố
      { key: "D", text: "23", isCorrect: false },
    ],
  },
  {
    id: 6,
    questionText: "Nếu 1=5, 2=25, 3=325, 4=4325. Thì 5=?",
    options: [
      { key: "A", text: "54325", isCorrect: false },
      { key: "B", text: "1", isCorrect: true }, // Nếu 1=5 thì 5=1 (Logic đảo ngược cơ bản)
      { key: "C", text: "5", isCorrect: false },
      { key: "D", text: "25", isCorrect: false },
    ],
  },
  {
    id: 7,
    questionText:
      "Tính nhanh: 1000 + 40 + 1000 + 30 + 1000 + 20 + 1000 + 10 = ?",
    options: [
      { key: "A", text: "5000", isCorrect: false },
      { key: "B", text: "4100", isCorrect: true }, // Rất nhiều người nhầm thành 5000
      { key: "C", text: "4090", isCorrect: false },
      { key: "D", text: "6000", isCorrect: false },
    ],
  },
  {
    id: 8,
    questionText: "Số tiếp theo: 3, 7, 15, 31, 63, ...",
    options: [
      { key: "A", text: "95", isCorrect: false },
      { key: "B", text: "127", isCorrect: true }, // Nhân 2 cộng 1
      { key: "C", text: "126", isCorrect: false },
      { key: "D", text: "132", isCorrect: false },
    ],
  },
  {
    id: 9,
    questionText: "Số còn thiếu trong ngoặc: 12 (56) 16 và 17 (?) 21",
    options: [
      { key: "A", text: "68", isCorrect: false },
      { key: "B", text: "76", isCorrect: true }, // (Số đầu + Số cuối) * 2 => (17+21)*2 = 76
      { key: "C", text: "65", isCorrect: false },
      { key: "D", text: "80", isCorrect: false },
    ],
  },
  {
    id: 10,
    questionText: "Một nửa của 2 cộng 2 bằng mấy?",
    options: [
      { key: "A", text: "3", isCorrect: true }, // (2/2) + 2 = 1 + 2 = 3 (Theo thứ tự phép tính)
      { key: "B", text: "2", isCorrect: false },
      { key: "C", text: "4", isCorrect: false },
      { key: "D", text: "1", isCorrect: false },
    ],
  },

  // --- PHẦN 2: TƯ DUY NGÔN NGỮ & LOGIC (12 Câu) ---
  {
    id: 11,
    questionText: "Cái nào không thuộc nhóm còn lại?",
    options: [
      { key: "A", text: "Hổ", isCorrect: false },
      { key: "B", text: "Sư tử", isCorrect: false },
      { key: "C", text: "Báo", isCorrect: false },
      { key: "D", text: "Cá mập", isCorrect: true }, // Dưới nước
    ],
  },
  {
    id: 12,
    questionText: "Bác sĩ : Bệnh viện :: Giáo viên : ?",
    options: [
      { key: "A", text: "Học sinh", isCorrect: false },
      { key: "B", text: "Trường học", isCorrect: true },
      { key: "C", text: "Phấn", isCorrect: false },
      { key: "D", text: "Sách", isCorrect: false },
    ],
  },
  {
    id: 13,
    questionText: "Chữ cái tiếp theo trong dãy: A, C, F, J, O, ...",
    options: [
      { key: "A", text: "S", isCorrect: false },
      { key: "B", text: "T", isCorrect: false },
      { key: "C", text: "U", isCorrect: true }, // +2, +3, +4, +5, +6 (O là 15, 15+6=21 => U)
      { key: "D", text: "V", isCorrect: false },
    ],
  },
  {
    id: 14,
    questionText:
      "Sắp xếp các chữ cái: 'H N Í M C I H' thành tên một địa danh.",
    options: [
      { key: "A", text: "Hải Phòng", isCorrect: false },
      { key: "B", text: "Hà Giang", isCorrect: false },
      { key: "C", text: "Hồ Chí Minh", isCorrect: true },
      { key: "D", text: "Hòa Bình", isCorrect: false },
    ],
  },
  {
    id: 15,
    questionText: "Nếu Mèo = 3, Chó = 3, Gà = 2. Thì Hổ = ?",
    options: [
      { key: "A", text: "2", isCorrect: true }, // Số lượng chữ cái trong tên tiếng Việt
      { key: "B", text: "4", isCorrect: false },
      { key: "C", text: "3", isCorrect: false },
      { key: "D", text: "5", isCorrect: false },
    ],
  },
  {
    id: 16,
    questionText: "Ngón tay đối với Bàn tay tương tự như Lá đối với...",
    options: [
      { key: "A", text: "Cây", isCorrect: false },
      { key: "B", text: "Cành cây", isCorrect: true }, // Mối quan hệ bộ phận trực tiếp
      { key: "C", text: "Hoa", isCorrect: false },
      { key: "D", text: "Rễ", isCorrect: false },
    ],
  },
  {
    id: 17,
    questionText: "Từ nào trái nghĩa với 'Lạc quan'?",
    options: [
      { key: "A", text: "Vui vẻ", isCorrect: false },
      { key: "B", text: "Bi quan", isCorrect: true },
      { key: "C", text: "Khách quan", isCorrect: false },
      { key: "D", text: "Chủ quan", isCorrect: false },
    ],
  },
  {
    id: 18,
    questionText: "Cụm từ nào khác biệt: Mắt, Mũi, Miệng, Phổi",
    options: [
      { key: "A", text: "Mắt", isCorrect: false },
      { key: "B", text: "Mũi", isCorrect: false },
      { key: "C", text: "Phổi", isCorrect: true }, // Cơ quan nội tạng, các cái còn lại ở trên mặt
      { key: "D", text: "Miệng", isCorrect: false },
    ],
  },
  {
    id: 19,
    questionText:
      "Nếu hôm qua là ngày mai của thứ Hai, thì hôm nay là thứ mấy?",
    options: [
      { key: "A", text: "Thứ Tư", isCorrect: true }, // Ngày mai của T2 là T3 (Hôm qua là T3) -> Hôm nay là T4
      { key: "B", text: "Thứ Năm", isCorrect: false },
      { key: "C", text: "Thứ Ba", isCorrect: false },
      { key: "D", text: "Chủ Nhật", isCorrect: false },
    ],
  },
  {
    id: 20,
    questionText:
      "Jack là cha của Mary. Mary là con gái của Anna. Hỏi quan hệ giữa Jack và Anna?",
    options: [
      { key: "A", text: "Cha - Con", isCorrect: false },
      { key: "B", text: "Vợ - Chồng", isCorrect: true },
      { key: "C", text: "Anh - Em", isCorrect: false },
      { key: "D", text: "Không có quan hệ", isCorrect: false },
    ],
  },
  {
    id: 21,
    questionText: "Điều gì bạn có thể giữ ngay cả khi đã cho người khác?",
    options: [
      { key: "A", text: "Tiền bạc", isCorrect: false },
      { key: "B", text: "Lời hứa", isCorrect: true },
      { key: "C", text: "Thức ăn", isCorrect: false },
      { key: "D", text: "Quần áo", isCorrect: false },
    ],
  },
  {
    id: 22,
    questionText:
      "Con gì buổi sáng đi 4 chân, buổi trưa đi 2 chân, buổi chiều đi 3 chân?",
    options: [
      { key: "A", text: "Con cua", isCorrect: false },
      { key: "B", text: "Con người", isCorrect: true }, // Ẩn dụ về cuộc đời (trẻ em, trưởng thành, già chống gậy)
      { key: "C", text: "Con khỉ", isCorrect: false },
      { key: "D", text: "Con chó", isCorrect: false },
    ],
  },

  // --- PHẦN 3: TƯ DUY KHÔNG GIAN & SUY LUẬN (8 Câu) ---
  {
    id: 23,
    questionText:
      "Nếu bạn xoay ngang hình chữ nhật, bạn vẫn có hình chữ nhật. Nếu bạn lật ngược hình tam giác đều, bạn có gì?",
    options: [
      { key: "A", text: "Hình vuông", isCorrect: false },
      { key: "B", text: "Hình thoi", isCorrect: false },
      { key: "C", text: "Hình tam giác ngược", isCorrect: true },
      { key: "D", text: "Hình tròn", isCorrect: false },
    ],
  },
  {
    id: 24,
    questionText:
      "Bạn đang chạy đua. Bạn vượt qua người thứ 2. Bạn đang ở vị trí nào?",
    options: [
      { key: "A", text: "Thứ nhất", isCorrect: false },
      { key: "B", text: "Thứ hai", isCorrect: true }, // Bạn thế chỗ người thứ 2
      { key: "C", text: "Thứ ba", isCorrect: false },
      { key: "D", text: "Thứ tư", isCorrect: false },
    ],
  },
  {
    id: 25,
    questionText: "Tháng nào trong năm có 28 ngày?",
    options: [
      { key: "A", text: "Tháng 2", isCorrect: false },
      { key: "B", text: "Tháng 12", isCorrect: false },
      { key: "C", text: "Chỉ năm nhuận", isCorrect: false },
      { key: "D", text: "Tất cả các tháng", isCorrect: true }, // Mọi tháng đều có ít nhất 28 ngày
    ],
  },
  {
    id: 26,
    questionText:
      "Trong một hộp có 3 đôi tất đen và 3 đôi tất trắng. Bạn cần lấy ra ít nhất bao nhiêu chiếc (nhắm mắt) để chắc chắn có 1 đôi cùng màu?",
    options: [
      { key: "A", text: "2", isCorrect: false },
      { key: "B", text: "3", isCorrect: true }, // Nguyên lý Dirichlet (Pigeonhole principle)
      { key: "C", text: "4", isCorrect: false },
      { key: "D", text: "5", isCorrect: false },
    ],
  },
  {
    id: 27,
    questionText:
      "Nam đi về phía Bắc 5km, sau đó rẽ trái đi 3km, rồi rẽ trái đi 5km. Hỏi Nam đang ở hướng nào so với điểm xuất phát?",
    options: [
      { key: "A", text: "Đông", isCorrect: false },
      { key: "B", text: "Tây", isCorrect: true },
      { key: "C", text: "Nam", isCorrect: false },
      { key: "D", text: "Bắc", isCorrect: false },
    ],
  },
  {
    id: 28,
    questionText: "A cao hơn B. C thấp hơn A. Kết luận nào chắc chắn đúng?",
    options: [
      { key: "A", text: "B cao hơn C", isCorrect: false },
      { key: "B", text: "B thấp hơn C", isCorrect: false },
      { key: "C", text: "A cao nhất", isCorrect: true },
      { key: "D", text: "B và C bằng nhau", isCorrect: false },
    ],
  },
  {
    id: 29,
    questionText: "Nhìn vào dãy số: 80, 10, 70, 15, 60, ... Số tiếp theo là?",
    options: [
      { key: "A", text: "20", isCorrect: true }, // Hai dãy xen kẽ: (80, 70, 60) và (10, 15, 20)
      { key: "B", text: "25", isCorrect: false },
      { key: "C", text: "50", isCorrect: false },
      { key: "D", text: "55", isCorrect: false },
    ],
  },
  {
    id: 30,
    questionText: "Nước đá : Nước lỏng :: Hơi nước : ?",
    options: [
      { key: "A", text: "Khí", isCorrect: false },
      { key: "B", text: "Mây", isCorrect: false },
      { key: "C", text: "Mưa", isCorrect: false },
      { key: "D", text: "Nước lỏng", isCorrect: true }, // Quá trình ngưng tụ ngược lại với nóng chảy
    ],
  },

  // --- PHẦN 4: CÂU HỎI HỖN HỢP & MẸO (12 Câu) ---
  {
    id: 31,
    questionText:
      "Tổng số tuổi của cha và con là 66. Tuổi cha gồm các chữ số giống tuổi con nhưng đảo ngược. Hỏi tuổi họ là bao nhiêu (biết cha hơn con nhiều tuổi)?",
    options: [
      { key: "A", text: "60 và 6", isCorrect: false },
      { key: "B", text: "51 và 15", isCorrect: true }, // 51+15=66, đảo ngược ok
      { key: "C", text: "42 và 24", isCorrect: false },
      { key: "D", text: "33 và 33", isCorrect: false },
    ],
  },
  {
    id: 32,
    questionText: "Cái gì càng nhiều thì bạn càng thấy ít?",
    options: [
      { key: "A", text: "Ánh sáng", isCorrect: false },
      { key: "B", text: "Bóng tối", isCorrect: true },
      { key: "C", text: "Nước", isCorrect: false },
      { key: "D", text: "Tiền", isCorrect: false },
    ],
  },
  {
    id: 33,
    questionText: "Điền số thiếu: 2, 6, 12, 20, 30, ...",
    options: [
      { key: "A", text: "40", isCorrect: false },
      { key: "B", text: "36", isCorrect: false },
      { key: "C", text: "42", isCorrect: true }, // +4, +6, +8, +10, +12
      { key: "D", text: "48", isCorrect: false },
    ],
  },
  {
    id: 34,
    questionText: "Nếu PEACH là HCAEP thì 46251 là...",
    options: [
      { key: "A", text: "15264", isCorrect: true }, // Đảo ngược chuỗi
      { key: "B", text: "12654", isCorrect: false },
      { key: "C", text: "51264", isCorrect: false },
      { key: "D", text: "15624", isCorrect: false },
    ],
  },
  {
    id: 35,
    questionText: "1/4 của 1/2 của 100 là bao nhiêu?",
    options: [
      { key: "A", text: "25", isCorrect: false },
      { key: "B", text: "50", isCorrect: false },
      { key: "C", text: "12.5", isCorrect: true },
      { key: "D", text: "10", isCorrect: false },
    ],
  },
  {
    id: 36,
    questionText: "Vật nào không cùng loại: Bàn, Ghế, Tủ, Giường, Máy tính",
    options: [
      { key: "A", text: "Giường", isCorrect: false },
      { key: "B", text: "Tủ", isCorrect: false },
      { key: "C", text: "Máy tính", isCorrect: true }, // Đồ điện tử, còn lại là nội thất gỗ
      { key: "D", text: "Bàn", isCorrect: false },
    ],
  },
  {
    id: 37,
    questionText:
      "Nếu bạn viết các số từ 1 đến 100, bạn viết số 9 bao nhiêu lần?",
    options: [
      { key: "A", text: "10", isCorrect: false },
      { key: "B", text: "11", isCorrect: false },
      { key: "C", text: "19", isCorrect: false },
      { key: "D", text: "20", isCorrect: true }, // 9,19,29...89,90,91...99 (số 99 có 2 số 9)
    ],
  },
  {
    id: 38,
    questionText: "Hình lục giác có bao nhiêu cạnh?",
    options: [
      { key: "A", text: "5", isCorrect: false },
      { key: "B", text: "6", isCorrect: true },
      { key: "C", text: "7", isCorrect: false },
      { key: "D", text: "8", isCorrect: false },
    ],
  },
  {
    id: 39,
    questionText: "Từ nào không cùng nhóm: Vàng, Đồng, Bạc, Chì, Nhựa",
    options: [
      { key: "A", text: "Chì", isCorrect: false },
      { key: "B", text: "Nhựa", isCorrect: true }, // Không phải kim loại
      { key: "C", text: "Đồng", isCorrect: false },
      { key: "D", text: "Vàng", isCorrect: false },
    ],
  },
  {
    id: 40,
    questionText: "Số tiếp theo: 1, 8, 27, 64, ...",
    options: [
      { key: "A", text: "100", isCorrect: false },
      { key: "B", text: "125", isCorrect: true }, // Lập phương (1^3, 2^3, 3^3, 4^3, 5^3)
      { key: "C", text: "81", isCorrect: false },
      { key: "D", text: "216", isCorrect: false },
    ],
  },
  {
    id: 41,
    questionText:
      "Có 3 quả táo trên bàn. Bạn lấy đi 2 quả. Bạn có bao nhiêu quả táo?",
    options: [
      { key: "A", text: "3", isCorrect: false },
      { key: "B", text: "1", isCorrect: false },
      { key: "C", text: "2", isCorrect: true }, // Bạn lấy 2 quả thì bạn có 2 quả
      { key: "D", text: "0", isCorrect: false },
    ],
  },
  {
    id: 42,
    questionText: "Chữ cái nào còn thiếu: J, F, M, A, M, J, J, A, S, O, N, ...",
    options: [
      { key: "A", text: "D", isCorrect: true }, // Chữ cái đầu của các tháng trong năm (December)
      { key: "B", text: "P", isCorrect: false },
      { key: "C", text: "K", isCorrect: false },
      { key: "D", text: "L", isCorrect: false },
    ],
  },
];
